import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-horizontal-wrapper',
  template: `
    <div class="row mb-3 align-items-top">
      <label 
        [attr.for]="id"   
        [class]="'col-12 col-md-3 col-form-label ' + (props['labelClass'] || '')"
        *ngIf="props.label" 
        [title]="props.label"
        style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
      >
        {{ props.label }}
        <ng-container *ngIf="props.required && props['hideRequiredMarker'] !== true">*</ng-container>
      </label>

      <div class="col-12 col-md-9" [ngClass]="props['inputClass']">
        <ng-template #fieldComponent></ng-template>
      </div>

      <div *ngIf="showError" class="col-12 col-md-9 offset-md-3 w-auto invalid-feedback d-block">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>
    </div>
  `,
  standalone: false
})
export class FormlyHorizontalWrapper extends FieldWrapper { }